import course from './courses';
import billing from './billing';
import anchor from './anchor';
import anchor2 from './anchor2';
import word from './word';
import pdf from './pdf';
import excel from './excel';
import csv from './csv';
import pound from './pound';
import dollar from './dollar';
import websail from './websail';
import backpack from './backpack';
import veranstaltungsbutler from './veranstaltungsbutler';

const icons = {
    course,
    billing,
    anchor,
    anchor2,
    csv,
    word,
    pdf,
    excel,
    pound,
    websail,
    backpack,
    veranstaltungsbutler,
    dmyv: veranstaltungsbutler,
    hic: veranstaltungsbutler
};

const iconStyles = {
};

export { icons, iconStyles };